export default __webpack_public_path__ + "static/media/me.4e812ec5.png";